import React, { useState } from "react";
import { Select, Input, Radio, Space, Typography } from "antd";
import classDdl from "../../models/control/dropdownlist";
import { renderOption } from "../../constants/utils";

const { Option } = Select;
const { Title } = Typography;
const numberFilterOptions = [
  { value: "(設定しない)", key: "0" },
  { value: "指定の値に等しい", key: "1" },
  { value: "指定の値に等しくない", key: "2" },
  { value: "指定の値より大きい", key: "3" },
  { value: "指定の値以上", key: "4" },
  { value: "指定の値より小さい", key: "5" },
  { value: "指定の値以下", key: "6" },
];
const stringFilterOptions = [
  { value: "（設定しない）", key: "0" },
  { value: "指定の値に等しい", key: "1" },
  { value: "指定の値に等しくない", key: "2" },
  { value: "指定の値で始まる", key: "3" },
  { value: "指定の値で終わる", key: "4" },
  { value: "指定の値を含む", key: "5" },
  { value: "指定の値を含まない", key: "6" },
];
const FilterCondition = ({ type, conditionObj, setConditionObj }) => {
  const filterOptions =
    type === "number" ? numberFilterOptions : stringFilterOptions;

  const handleConditionValue = (key) => (e) => {
    if (type === "number") {
      if (!/^-?\d*$/.test(e.target.value)) {
        return;
      }
    }
    setConditionObj({
      ...conditionObj,
      [key]: e.target.value,
    });
  };
  return (
    <div style={{}}>
      <div style={{ textAlign: "center" }}>抽出条件の指定</div>
      <Select
        onChange={(v) =>
          setConditionObj({
            ...conditionObj,
            condition1: v,
          })
        }
        value={conditionObj.condition1}
        style={{ width: "100%", marginBottom: 8 }}
      >
        {renderOption(filterOptions, false)}
      </Select>
      <Input
        disabled={conditionObj.condition1 === "0"}
        value={conditionObj.conditionValue1}
        onChange={handleConditionValue("conditionValue1")}
        style={{ marginBottom: 8 }}
      />

      {/* AND/OR */}
      <Radio.Group
        value={conditionObj.operator}
        onChange={(e) =>
          setConditionObj({
            ...conditionObj,
            operator: e.target.value,
          })
        }
        style={{ marginBottom: 8 }}
      >
        <Space>
          <Radio value="AND">AND</Radio>
          <Radio value="OR">OR</Radio>
        </Space>
      </Radio.Group>

      <Select
        onChange={(v) =>
          setConditionObj({
            ...conditionObj,
            condition2: v,
          })
        }
        value={conditionObj.condition2}
        style={{ width: "100%", marginBottom: 8 }}
      >
        {renderOption(filterOptions, false)}
      </Select>
      <Input
        disabled={conditionObj.condition2 === "0"}
        value={conditionObj.conditionValue2}
        onChange={handleConditionValue("conditionValue2")}
      />
    </div>
  );
};

export default FilterCondition;
